import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Comments';

const CommentApi: any = baseApi(endpoint);

export default CommentApi;